import { Button, Flex } from '@chakra-ui/react';
import { BrowserView, MobileView } from 'react-device-detect';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { AuthenticatedComponent, isAuthenticated } from '../auth/keycloak';
import { Membership } from '../component/settingsComponents/Membership';
import { MembershipPerkList } from '../component/settingsComponents/MembershipPerkList';
import { StreamsixBanner } from '../component/setupComponents/StreamsixBanner';

export const SetupMembership: AuthenticatedComponent = ({ keycloak }) => {
    const navigate = useNavigate();

    const renderSetupMembership = () => (
        <Flex className="setup-membership-container">
            <StreamsixBanner className="setup-membership-banner" />
            <MembershipPerkList />
            {isAuthenticated(keycloak) && <Membership keycloak={keycloak} />}
            <Button className="setup-membership-button" isDisabled={true}>
                <FormattedMessage
                    id="setup-membership.purchase"
                    defaultMessage="Membership $9.99"
                />
            </Button>
            <Button className="setup-membership-button" onClick={() => navigate('/hosts')}>
                <FormattedMessage id="global.skip_for_now" defaultMessage="Skip for Now" />
            </Button>
        </Flex>
    );

    return (
        <>
            <BrowserView>
                <Flex className="setup-membership-browser-content">{renderSetupMembership()}</Flex>
            </BrowserView>
            <MobileView>
                <Flex className="setup-membership-mobile-content">{renderSetupMembership()}</Flex>
            </MobileView>
        </>
    );
};
